import { createAction } from '@reduxjs/toolkit';
export const FETCH_CONTACT = 'FETCH_CONTACT';
export const fetchContactAction = createAction(FETCH_CONTACT);